import Switch from './CustomSwitch';

export default Switch;
